
















































































































































































































































































































































































































































































































import 'reflect-metadata'
import { Component, Vue, Watch } from 'vue-property-decorator'

import DataTableTransferPlanning from "@/components/planning-cr/datatable/DataTableTransferPlanning.vue"
//component
import DropDownProject from "@/components/common/combobox/DropDownProject.vue"
import DropDownManageUnit from "@/components/common/combobox/DropDownManageUnit.vue"
import DatePickerFromTo from "@/components/common/date-picker/DatePickerFromTo.vue"
import DropDownFixData from "@/components/common/combobox/DropDownFixData.vue"
import DatePicker from "@/components/common/date-picker/DatePicker.vue"
import Notification from "@/components/common/notification/Notification.vue"
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import EmailDialog from "@/components/planning-cr/email/EmailDialog.vue"
import { AuthenticateApi } from "@/api"
import { namespace } from 'vuex-class'

import { 
        SaleApi, 
        ProjectApi, 
        MasterDataApi,
        UnitApi, 
        CRNameApi,
        PlanningTransferApi,
        PdpaApi
    } from '@/api'
    
import { SetSearchRequest, SetTableDataObject, AddQCInspection, AddPDPA, IDataTableTransferPlanning, SetJsonSearchRefresh, AddIBNonIB } from "@/resource/planning-cr/ModifyJsonData"
import { ValidateTransferSave, ValidateTransferSaveSendEmail, ValidateSearch } from '@/resource/planning-cr/TransferPlanningValidate'
import { ExportExcel } from '@/resource/planning-cr/ExportExcel'

const Auth = namespace('authentication')

@Component({
    components: {
        'common-combobox-dropdownproject': DropDownProject,
        'common-combobox-dropdownmanageunit': DropDownManageUnit,
        'common-date-picker-datepickerfromto': DatePickerFromTo,
        'common-date-picker-dropdownfixdata': DropDownFixData,
        'common-date-picker-datepicker': DatePicker,
        'common-notification-notification': Notification,
		DataTableTransferPlanning,
        BreadcrumbsPath,
        EmailDialog
    }
})



export default class TransferPlanning extends Vue { 

    panel = 0
    loading = false

    permissionSave = false

    @Auth.State('auth') auth!: any

    totalUnit = '0'
    totalNetPrice = '0'
    
    jsonData = {
        projectName: "",
        projectId: "",
        unitSelectType: "unitAll",
        unitSelected: [],
        unitFrom: "",
        unitTo: "",
        statusSold: ["Sold", "Unsold"],
        bookingDateTo: "",
        bookingDateFrom: "",
        contractDateFrom: "",
        contractDateTo: "",
        contractTransferDateFrom: "",
        contractTransferDateTo: "",
        finalTransferDateFrom: "",
        finalTransferDateTo: "",
        crPlanDateFrom: "",
        crPlanDateTo: "",
        transferPlanDateFrom: "",
        transferPlanDateTo: "",
        transferStatusId: "",
        recieceStatus: "",
        crId: "",
        salesId: "",
        customerNationality: "",
        deliveryStatus: "",
        nationalityType: "",
        paymentMethodsId: "0",
        selectBoxUpdateALLCrName: "",
        productType: "",
        emailType: 0,
        addressNoText: "",
    } as any

    isColumnQCInspection = false
    isColumnPDPA = false
    isColumnIBNonIB = false

    paymentMethodLists = [] as any
    projectLists = [] as any
    unitLists = [] as any
    crNameLists = [] as any
    salesLists = [] as any
    crNameItemData: any = []

    masterContractStatus: any = [] 
    masterReceivePromotionData: any = [] 
    masterJoinEventData: any = [] 
    masterPurposeOfBuyData: any = [] 
    masterInspection1AppointmentStatusData: any = [] 
    masterTransferStatus: any = [] 
    masterTransferType: any = [] 
    masterTransferPlanOperation: any = [] 
    masterPayStatusType: any = []
    masterPayStatusCusOverPayType: any = []
    masterEmailTypeLists: any = []
    masterBankReason: any = []
    
    transferItemData = [
		{ id: 1 , name: 'โอนแล้ว', value: 1 },
		{ id: 2 , name: 'ยังไม่โอน', value: 0 },
	] as any

    recieveTypeItemData = [
		{ id: 1 , name: 'การรับมอบทั้งหมด', value: '209,210' },
		{ id: 2 , name: 'การรับมอบสมบูรณ์', value: '209' },
		{ id: 3 , name: 'การรับมอบแบบมีเงื่อนไข', value: '210' },
		{ id: 4 , name: 'ยังไม่รับมอบ', value: '208,0' },
	] as any

    nationalityItemData = [
		{ id: 1 , name: 'ไทย', value: 'TH' },
		{ id: 2 , name: 'ต่างชาติ', value: 'EN' },
	] as any

    jsonUpdateColumn = {
        rdoTypeUpdateDateColumn: "transferDateReal" as string,
        typeUpdateDateColumnValue: "" as string,
        datePickerUpdateColumn: "" as string,
        recieveFormUpdateColumn: "" as string
    } as any

    created () {
		this.startup()
	}

    @Watch("jsonData.projectId")
    async onProjectIdChange(val: string, oldVal: string) {
        this.loading = true
        if (val === undefined) {
            this.openNotification("กรุณากรอกชื่อโครงการให้ถูกต้อง", "warning")
            this.loading = false
            return 
        }

        this.unitLists = await UnitApi.GetUnitListsByProjectId(val)
        let crNameItemData = await CRNameApi.GetCRNamePJByProjectId(val)
        if (crNameItemData!.length > 0 && crNameItemData != undefined) {
            this.crNameItemData = crNameItemData.map((x, index) => ({ id: index, name: x.name, value: x.id , active: x.active}))
        }
        this.RestFrom()
        this.loading = false
    }

    async startup () {
        this.loading = true


        const getUserInfo = await AuthenticateApi.GetUserInfo()

        const hasMatchingPermission = getUserInfo?.permission.filter((filter) => 
            filter.profileCode === "TFP-01" || filter.profileCode === "TFP-02"
            );

        var hasSavePermission = getUserInfo?.permission.filter((x => x.profileCode === "TFP-02" ));

        if (hasSavePermission && hasSavePermission?.length > 0) {
            this.permissionSave = true;
        }

        if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
            //clear Authen
            localStorage.clear()
		    window.location.reload()
        }
        
        await Promise.all([
            MasterDataApi.GetMasterDataVlookupByType("OB_Payment").then(response => {
                this.paymentMethodLists = response.map((x: any, index: any) => ({ id: index, name: x.descriptionTH, value: x.id }))
            }),
            ProjectApi.GetProjectLists().then(response => {
                this.projectLists = response
            }),
            SaleApi.GetSalesLists().then(response => {
                this.salesLists = response.map((x: any, index: any) => ({ id: index, name: x.name, value: x.id }))
            }),
            MasterDataApi.GetMasterDataByType('ContractStatus').then(response => {
                this.masterContractStatus = response
            }),
            MasterDataApi.GetMasterDataByType('ReceivePromotion').then(response => {
                this.masterReceivePromotionData = response
            }),
            MasterDataApi.GetMasterDataByType('JoinEvent').then(response => {
                this.masterJoinEventData = response
            }),
            MasterDataApi.GetMasterDataByType('PurposeOfBuy').then(response => {
                this.masterPurposeOfBuyData = response
            }),
            MasterDataApi.GetMasterDataByType('AppointmentStatus').then(response => {
                this.masterInspection1AppointmentStatusData = response
            }),
            MasterDataApi.GetMasterDataByType('TransferStatus').then(response => {
                this.masterTransferStatus = response
            }),
            MasterDataApi.GetMasterDataVlookupByType('TransferType').then(response => {
                this.masterTransferType = response
            }),
            MasterDataApi.GetMasterDataVlookupByType('TransferPlan_Operation').then(response => {
                this.masterTransferPlanOperation = response
            }),
            MasterDataApi.GetMasterDataByType('PayStatusType').then(response => {
                this.masterPayStatusType = response
            }),
            MasterDataApi.GetMasterDataByType('PayStatus_CusOverPayType').then(response => {
                this.masterPayStatusCusOverPayType = response
            }),
            MasterDataApi.GetMasterDataVlookupByType('BankReason').then(response => {
                this.masterBankReason = response
            }),
            MasterDataApi.GetMasterDataVlookupByType('TransferPlan_EmailTrans').then(response => {
                this.masterEmailTypeLists = response.map((x: any, index: any) => ({ id: index, name: x.code, value: x.id }))
            })
        ])
        console.log('this.masterPayStatusType', this.masterPayStatusType)
        this.loading = false
    }

    async GetSearchPlanningTransferData () {
        try {
            const jsonDataRequest = SetSearchRequest(this.jsonData)
            const responseData: PlanningTransferApi.ISearchPlanningTransferResponse[] = await PlanningTransferApi.SearchPlanningTransfer(jsonDataRequest)
            this.totalUnit = parseFloat(responseData.length.toString()).toLocaleString()
            let totalNetPrice = responseData.reduce(function (total, currentValue) {
                return total + currentValue.netPrice;
            }, 0)
            this.totalNetPrice = parseFloat(totalNetPrice.toString()).toLocaleString()

            return responseData
        } catch {
            throw new Error
        }
    }

    async RefreshSearchPlanningTransferData (unitIds: string[]) {
        try {
            const jsonSearchRefresh = SetJsonSearchRefresh(this.jsonData.projectId, unitIds)
            const responseData: PlanningTransferApi.ISearchPlanningTransferResponse[] = await PlanningTransferApi.SearchPlanningTransfer(jsonSearchRefresh)
            return responseData
        } catch {
            throw new Error
        }
    }

    async RefreshTableDataTransfer (unitListsSelected: string[]) {
        try {
            const jsonSearchRefresh = await this.RefreshSearchPlanningTransferData(unitListsSelected)
            console.log('jsonSearchRefresh', jsonSearchRefresh)
            let planningTransferDataForDatatable = SetTableDataObject(jsonSearchRefresh)
            const { msgQcAndPdpaError, headerPdpa, planningTransferDataOG } = await this.AddQCAndPDPA(planningTransferDataForDatatable)
            planningTransferDataForDatatable = planningTransferDataOG
            const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
            refDataTableTransferPlanning.UpdateDataTableByUnitId(planningTransferDataForDatatable)
            refDataTableTransferPlanning.SetCheckBoxByUnitIdDataTable(unitListsSelected)
        } catch {
            throw new Error
        }
    }

    async AddQCAndPDPA (planningTransferDataOG: IDataTableTransferPlanning[]) {
        let msgQcAndPdpaErrorArr: Array<string> = []
        if (this.isColumnQCInspection) {
            const { status, planningTransferData } = await AddQCInspection(planningTransferDataOG, this.jsonData.unitSelectType)
            if (status === "OK") {
                planningTransferDataOG = planningTransferData
            } else {
                msgQcAndPdpaErrorArr.push("QC")
            }
        }

        let headerPdpa: PdpaApi.IPdpaCollection[] = []
        if (this.isColumnPDPA) {
            const { status, collectionIds, planningTransferData } = await AddPDPA(planningTransferDataOG)
            if (status === "OK") {
                headerPdpa = collectionIds as PdpaApi.IPdpaCollection[]
                planningTransferDataOG = planningTransferData
            } else {
                msgQcAndPdpaErrorArr.push("PDPA")
            }
        }

        if (this.isColumnIBNonIB) {
            const { status, planningTransferData } = await AddIBNonIB(this.jsonData.projectId, planningTransferDataOG)
            if (status === "OK") {
                planningTransferDataOG = planningTransferData
            } else {
                msgQcAndPdpaErrorArr.push("IB/NON-IB")
            }
        }

        let msgQcAndPdpaError = ""
        if (msgQcAndPdpaErrorArr.length > 0) {
            msgQcAndPdpaError = msgQcAndPdpaErrorArr.join(" ")
        } else msgQcAndPdpaError = ""

        return {
            msgQcAndPdpaError,
            headerPdpa,
            planningTransferDataOG
        }
    }

    async BtnSearch () {
        this.loading = true
        try { 

            const validate = ValidateSearch(this.jsonData)
            if (validate.status === false) {
                this.openNotification(validate.msg, "warning")
                this.loading = false
                return
            }

            const planningTransferData: PlanningTransferApi.ISearchPlanningTransferResponse[] = await this.GetSearchPlanningTransferData()

            this.jsonData.projectName = this.projectLists.find((x: any) => x.id === this.jsonData.projectId).name || ""
            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSearchCR Data Found : " + planningTransferData.length.toString() + " Records",
                page: "TransferPlaningCR",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };
            PlanningTransferApi.addLog(logModel)

            const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
            refDataTableTransferPlanning.ResetDataTable()
            if (planningTransferData.length > 0) {

                let planningTransferDataForDatatable = SetTableDataObject(planningTransferData)


                const { msgQcAndPdpaError, headerPdpa, planningTransferDataOG } = await this.AddQCAndPDPA(planningTransferDataForDatatable)
                planningTransferDataForDatatable = planningTransferDataOG
                
                
                refDataTableTransferPlanning.UpdateDataTable(planningTransferDataForDatatable, headerPdpa, this.isColumnQCInspection, this.isColumnIBNonIB)

                if (this.jsonData.unitSelectType === 'unitSelected' || this.jsonData.unitSelectType === 'unitRange') refDataTableTransferPlanning.SetCheckBoxAllDataTable()

                if (msgQcAndPdpaError !== "") this.openNotification(`ไม่สามารถโหลดข้อมูล ${msgQcAndPdpaError} ได้ ถ้าต้องการกรุณากดค้นหาอีกครั้ง`, "warning")
                this.loading = false
                return
            } else {
                this.openNotification("ไม่มีข้อมูลยูนิตที่ค้นหา", "warning")
                this.loading = false
                return
            }
        } catch {
            this.openNotification("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่", "warning")
            this.loading = false
        }
    }

    async BtnSave () {
        try { 
            
            this.loading = true
            const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning

            const unitListsSelected = await refDataTableTransferPlanning.GetUnitSelected("WITHOUTEMAIL", 0, this.jsonData.projectId)
            const validate = ValidateTransferSave(unitListsSelected, this.jsonData.productType)
            if (validate.status === false) {
                this.openNotification(validate.msg, "warning")
                this.loading = false
                return
            }

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSaveCR",
                page: "TransferPlaningCR",
                json_data: JSON.stringify(unitListsSelected),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            if (unitListsSelected.length > 0) {
                console.log("obj :", "Save เข้าอยู่น่ะ")
                const result = await PlanningTransferApi.SavePlanningTransfer(unitListsSelected)

                if (result!.status === 'UPDATED') {
                    const unitListsUpdated = unitListsSelected.map((m: any) => (m.unitId.toString()))
                    
                    const jsonSearchRefresh = await this.RefreshSearchPlanningTransferData(unitListsUpdated)
                    let planningTransferDataForDatatable = SetTableDataObject(jsonSearchRefresh)
                    const { msgQcAndPdpaError, headerPdpa, planningTransferDataOG } = await this.AddQCAndPDPA(planningTransferDataForDatatable)
                    planningTransferDataForDatatable = planningTransferDataOG
                    refDataTableTransferPlanning.UpdateDataTableByUnitId(planningTransferDataForDatatable)
                    refDataTableTransferPlanning.SetCheckBoxByUnitIdDataTable(unitListsUpdated)

                    if (msgQcAndPdpaError !== "") this.openNotification(`ไม่สามารถโหลดข้อมูล ${msgQcAndPdpaError} ได้ ถ้าต้องการกรุณากดค้นหาอีกครั้ง`, "warning")

                    this.openNotification(`บัททึกข้อมูลสำเร็จ ${planningTransferDataForDatatable.length} ยูนิต` , "success")
                } else {
                    this.openNotification(result!.msg[0], "warning")
                }
                this.loading = false
                return
            } else {
                this.openNotification("กรุณาเลือก ยูนิตที่ต้องการ บันทึก", "warning")
            }
            this.loading = false
        } catch (e) {
            console.log('error save', e)
            this.openNotification("ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่", "warning")
            this.loading = false
        }
    }

    async btnSaveAndSendEmail () {
        try { 
            this.loading = true

            const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
            const unitListsSelected = await refDataTableTransferPlanning.GetUnitSelected("WITHEMAIL", this.jsonData.emailType, this.jsonData.projectId)

            if (unitListsSelected.length > 0) {
                const validate = ValidateTransferSaveSendEmail(unitListsSelected, this.jsonData)
                if (validate.status === false) {
                    this.openNotification(validate.msg, "warning")
                    this.loading = false
                    return
                }

                const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSaveAndSendEmail : " + this.jsonData.emailType.toString(),
                page: "TransferPlaningCR",
                json_data: JSON.stringify(unitListsSelected),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

                const result = await PlanningTransferApi.SavePlanningTransfer(unitListsSelected)
                if (result!.status === 'UPDATED') {
                    const unitListsUpdated = unitListsSelected.map((m: any) => (m.unitId.toString()))
                    const jsonSearchRefresh = await this.RefreshSearchPlanningTransferData(unitListsUpdated)
                    let planningTransferDataForDatatable = SetTableDataObject(jsonSearchRefresh)
                    const { msgQcAndPdpaError, headerPdpa, planningTransferDataOG } = await this.AddQCAndPDPA(planningTransferDataForDatatable)
                    planningTransferDataForDatatable = planningTransferDataOG
                    refDataTableTransferPlanning.UpdateDataTableByUnitId(planningTransferDataForDatatable)
                    refDataTableTransferPlanning.SetCheckBoxByUnitIdDataTable(unitListsUpdated)

                    this.OpenDialogSendEMail(unitListsSelected, this.jsonData.emailType, this.jsonData.projectId)
                } else {
                    this.openNotification(result!.msg.error[0], "warning")
                    this.loading = false
                }
            } else {
                this.openNotification("กรุณาเลือก ยูนิตที่ต้องการ บันทึก", "warning")
                this.loading = false
            }

            this.loading = false
        } catch (e) {
            this.openNotification("ไม่สามารถบันทึกข้อมูลได้ กรุณาลองใหม่", "warning")
            this.loading = false
        }
    }

    async OpenDialogSendEMail (jsonSelected: any, emailType: number, projectId: string) {
        const newJsonData = jsonSelected.map((x: any) => {
			return { 
				projectId: parseInt(projectId),
				unitId: parseInt(x.unitId),
                bookingId: parseInt(x.bookingId),
				unitCode: x.unitCode,
				emailType: emailType,
				flagTransferLetter: x.flagTransferLetter,
				flagTransferLetterBefore: x.flagTransferLetterBefore,
				flagTransferChange: x.flagTransferChangeLetter,
				flagTransferAdjust: x.flagTransferAdjustLetter,
				flagTransferCancel: x.flagTransferCancelLetter,
				flagTransferOut: x.flagTransferOutLetter,
				flagTransferOutCancel: x.flagTransferOutCancelLetter
			}
		})

        const refEmailDialog = this.$refs.refEmailDialog as EmailDialog
        refEmailDialog.OpenDialog(newJsonData)
    }

    async btnExportExcel () {
        this.loading = true
        try { 

            const validate = ValidateSearch(this.jsonData)
            if (validate.status === false) {
                this.openNotification(validate.msg, "warning")
                this.loading = false
                return
            }

            const planningTransferData: PlanningTransferApi.ISearchPlanningTransferResponse[] = await this.GetSearchPlanningTransferData()

            this.jsonData.projectName = this.projectLists.find((x: any) => x.id === this.jsonData.projectId).name || ""
            const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnExportExcel Data Found : " + planningTransferData.length.toString() + " Records",
                page: "TransferPlaningCR",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            if (planningTransferData.length > 0) {

                let planningTransferDataForDatatable = SetTableDataObject(planningTransferData)

                const { msgQcAndPdpaError, headerPdpa, planningTransferDataOG } = await this.AddQCAndPDPA(planningTransferDataForDatatable)
                planningTransferDataForDatatable = planningTransferDataOG
                
                if (msgQcAndPdpaError !== "") this.openNotification(`ไม่สามารถโหลดข้อมูล ${msgQcAndPdpaError} ได้ ถ้าต้องการกรุณากดค้นหาอีกครั้ง`, "warning")

                ExportExcel(planningTransferDataForDatatable, headerPdpa, 
                    { 
                        masterContractStatus: this.masterContractStatus, 
                        masterReceivePromotionData: this.masterReceivePromotionData, 
                        masterJoinEventData: this.masterJoinEventData,
                        masterPurposeOfBuyData: this.masterPurposeOfBuyData,
                        masterInspection1AppointmentStatusData: this.masterInspection1AppointmentStatusData,
                        masterTransferStatus: this.masterTransferStatus,
                        masterTransferType: this.masterTransferType,
                        masterTransferPlanOperation: this.masterTransferPlanOperation,
                        masterPayStatusType: this.masterPayStatusType,
                        masterPayStatusCusOverPayType: this.masterPayStatusCusOverPayType,
                        crNameLists: this.crNameItemData,
                    },
                    this.isColumnIBNonIB
                )

                this.openNotification("Export Excel สำเร็จ", "success")
                this.loading = false
                return
            } else {
                this.openNotification("ไม่มีข้อมูลยูนิตที่ค้นหา", "warning")
                this.loading = false
                return
            }
        } catch (ex: any) {
            console.log(ex)
            this.openNotification("ไม่สามารถโหลดข้อมูลได้ กรุณาลองใหม่", "warning")
            this.loading = false
        }

    }

    btnSelectedUnitUpdateDateColumn () {
        this.loading = true
        const { rdoTypeUpdateDateColumn, datePickerUpdateColumn } = this.jsonUpdateColumn
        if (datePickerUpdateColumn === "") {
            this.openNotification("กรุณาระบุวันที่ ที่ต้องการ Update", "warning")
            this.loading = false
            return
        }

        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSelectedUnitUpdateDateColumn",
                page: "TransferPlaningCR",
                json_data: JSON.stringify(this.jsonUpdateColumn),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

        const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
        refDataTableTransferPlanning.callUpdateDateByColumnName(rdoTypeUpdateDateColumn, datePickerUpdateColumn)
        this.loading = false
    }
    
    btnSelectedUnitUpdateCrNameColumn () {
        this.loading = true
        const logModel = {
                application_name: "Transfer_Planning",
                feature: "btnSelectedUnitUpdateCrNameColumn",
                page: "TransferPlaningCR",
                json_data: JSON.stringify(this.jsonData),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)
        const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
        refDataTableTransferPlanning.callUpdateCrNameByColumnName(this.jsonData.selectBoxUpdateALLCrName)
        this.loading = false
    }

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }

    isloading (loading: boolean) {
        loading === true ? this.loading = true : this.loading = false 
    }

    // ! change state
    changeState (key: string, value: string): void {
        this.jsonData[key] = value
        console.log('changeState', `key ${key}`, `value ${value}`)

        if (key === 'emailType') this.conditionEmailType(value)
    }

    changeStateJsonUpdateColumn (key: string, value: string): void {
        this.jsonUpdateColumn[key] = value
    }

    conditionEmailType (emailType: string) {
        const refDataTableTransferPlanning = this.$refs.dataTableTransferPlanning as DataTableTransferPlanning
        refDataTableTransferPlanning!.ConditionEmailType(emailType)
    }

    public $refs: Vue['$refs'] & {
        refBookingDateFromTo?: DatePickerFromTo,
        refContractDateFromTo?: DatePickerFromTo,
        refContractTransferDateFromTo?: DatePickerFromTo,
        refFinalTransferDateFromTo?: DatePickerFromTo,
        refCRPlanDateFromTo?: DatePickerFromTo,
        refTransferPlanDateFromTo?: DatePickerFromTo,
        refTransferStatusId?: DropDownFixData,
        refRecieceStatus?: DropDownFixData,
        refCRId?: DropDownFixData,
        refSalesId?: DropDownFixData,
        refNationalityType?: DropDownFixData,
        refPaymentMethodsId?: DropDownFixData,
        refCrNameItemData?: DropDownFixData,
        refEmailType?: DropDownFixData,
        refDataTableTransferPlanning? : DataTableTransferPlanning
    } = {}

    RestFrom () {
        this.$refs.refBookingDateFromTo!.clear()
        this.$refs.refContractDateFromTo!.clear()
        this.$refs.refContractTransferDateFromTo!.clear()
        this.$refs.refFinalTransferDateFromTo!.clear()
        this.$refs.refCRPlanDateFromTo!.clear()
        this.$refs.refTransferPlanDateFromTo!.clear()
        this.$refs.refTransferStatusId!.clear()
        this.$refs.refRecieceStatus!.clear()
        this.$refs.refCRId!.clear()
        this.$refs.refSalesId!.clear()
        this.$refs.refNationalityType!.clear()
        this.$refs.refPaymentMethodsId!.clear()
        this.$refs.refCrNameItemData!.clear()
        this.$refs.refEmailType!.clear()
        this.isColumnQCInspection = false
        this.isColumnPDPA = false
        this.isColumnIBNonIB = false
        this.jsonData.addressNoText = ""
    }

}
